// src/store/sagas/authSaga.ts
import {call, delay, put, race, takeLatest} from 'redux-saga/effects';
import {
  checkAuthFailure,
  checkAuthRequest,
  checkAuthSuccess,
  loginFailure,
  loginRequest,
  loginSuccess,
  logoutRequest,
  logoutSuccess
} from '../slices/authSlice';
import {PayloadAction} from '@reduxjs/toolkit';
import {AuthRequest} from '../../shared/types/auth-request';
import {loginFetch, logoutFetch} from "../../app/axios/authFetches";
import {Teacher} from "../../shared/types/teacher";
import {loadCurrentTeacherFetch} from "../../app/axios/teacherFetches";

const LOGIN_TIMEOUT = 30000; // 30 секунд

function* loginSaga(action: PayloadAction<AuthRequest>) {
  try {
    const { response, timeout } = yield race({
      response: call(loginFetch, action.payload),
      timeout: delay(LOGIN_TIMEOUT)
    });

    if (timeout) {
      yield put(loginFailure('Превышено время ожидания ответа сервера'));
      return;
    }

    if (response) {
      const teacher: Teacher = yield call(loadCurrentTeacherFetch);
      yield put(loginSuccess(teacher));
    } else {
      yield put(loginFailure('Неверный логин или пароль'));
    }
  } catch (error) {
    yield put(loginFailure('Ошибка аутентификации'));
  }
}

function* logoutSaga() {
  try {
    yield call(logoutFetch);
    yield put(logoutSuccess());
  } catch (error) {
    console.error('Ошибка при выходе:', error);
  }
}

function* checkAuthSaga() {
  try {
    const teacher: Teacher = yield call(loadCurrentTeacherFetch);
    yield put(checkAuthSuccess(teacher));
  } catch (error) {
    yield put(checkAuthFailure());
  }
}

export function* watchAuth() {
  yield takeLatest(checkAuthRequest.type, checkAuthSaga);
  yield takeLatest(loginRequest.type, loginSaga);
  yield takeLatest(logoutRequest.type, logoutSaga);
}